import * as React from 'react';

function Gift(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.121 7.898h-4.025c.281-.142.527-.3.773-.46.861-.619 1.336-1.414 1.336-2.21 0-.654-.316-1.238-.773-1.61-.44-.406-1.02-.618-1.653-.618-.685 0-1.283.23-1.828.583-.808.53-1.441 1.344-1.898 2.264L12 5.97a6.484 6.484 0 00-.58-1.007 5.37 5.37 0 00-1.371-1.38C9.52 3.23 8.889 3 8.22 3c-.668 0-1.266.265-1.74.707a2.382 2.382 0 00-.774 1.733c0 .424.106.831.352 1.22.316.477.773.902 1.441 1.238H3.879c-.475 0-.879.407-.879.902v3.253h8.49V7.898h1.037v4.155H21V8.8a.888.888 0 00-.879-.902zM4.6 21h6.89v-7.727H4.6V21zm7.927 0H19.4v-7.727h-6.873V21zM7.817 6.625c-.352-.23-.563-.442-.686-.637a1.14 1.14 0 01-.158-.548c0-.265.14-.583.369-.796.246-.23.58-.37.861-.37.404 0 .774.123 1.143.37.545.39 1.09 1.026 1.459 1.769.193.37.334.76.422 1.167-1.688-.177-2.795-.566-3.41-.955zm5.783-.92c.316-.442.668-.813 1.054-1.06.37-.248.756-.372 1.108-.372h.017c.334 0 .616.124.826.3a.838.838 0 01.317.655c0 .283-.14.69-.809 1.167-.633.46-1.722.937-3.375 1.273a6.3 6.3 0 01.862-1.963z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Gift;
